import { render, staticRenderFns } from "./Comprovante.vue?vue&type=template&id=cd5f4e1a"
import script from "./Comprovante.vue?vue&type=script&lang=js"
export * from "./Comprovante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports